import { Button, Col, Row, Spinner } from 'react-bootstrap';
import { deleteJwt, getHeaderObject } from '../../../../util/jwtProvider';
import * as React from 'react';
import { useEffect, useState } from 'react';
import Colors from '../../../../util/colors';
import { Link } from 'react-router-dom';
import ergebnis from '../Ergebnis';
type Props = {
  onRefresh: () => void;
};

const ErgebnisView = ({ onRefresh }: Props): JSX.Element => {
  const [pending, setPending] = useState(true);
  const [error, setError] = useState(false);
  const [content, setContent] = useState(null as Blob | null);

  const logout = () => {
    deleteJwt();
    onRefresh();
  };

  const download = () => {
    if (!content) return;

    const url = window.URL.createObjectURL(content);
    const a = document.createElement('a');
    a.href = url;
    a.download = 'Ergebnis.pdf';
    document.body.appendChild(a);
    a.click();
    a.remove();
    window.URL.revokeObjectURL(url);
  };

  useEffect(() => {
    fetch('/api/result.php', {
      method: 'GET',
      headers: getHeaderObject(),
    })
      .then(async response => {
        if (response.status === 404) {
          setPending(false);
          return;
        }
        if (!response.ok) {
          setPending(false);
          setError(true);
          return;
        }

        const blob = await response.blob();
        setContent(blob);
        setPending(false);
      })
      .catch(() => {
        setPending(false);
        setError(true);
      });
  }, []);

  const handleBack = () => {
    setError(false);
    setPending(true);
    setContent(null);

    logout();

    window.location.href = ergebnis.defaultRoute;
  };

  if (error) {
    return (
      <div>
        <p>
          <h4 style={{ color: Colors.red }}>Leider ist beim Lader der Seite ein Fehler aufgetreten</h4>
        </p>
        <p>
          <Link to="#" onClick={handleBack}>
            Zurück
          </Link>
        </p>
      </div>
    );
  }

  if (pending) {
    return (
      <div>
        <Spinner animation={'border'} />
      </div>
    );
  }

  if (!content) {
    return (
      <div>
        <p>
          <h4>Leider sind noch keine Ergebnisse vorhanden</h4>
        </p>
        <p>
          <Link to="#" onClick={handleBack}>
            Zurück
          </Link>
        </p>
      </div>
    );
  }

  return (
    <div>
      <Row>
        <Col md={'10'} className={'mb-3'}>
          <h3>Hier können Sie Ihre Ergebnisse runterladen</h3>
        </Col>
        <Col md={'2'}>
          <Button variant={'outline-danger'} as={Col} onClick={logout}>
            Abmelden
          </Button>
        </Col>
      </Row>
      <Row className={'mb-4'}>
        <Col>
          <span>Kurzer Beschreibungstext etc.</span>
        </Col>
      </Row>
      <Row>
        <Col>
          <Button onClick={download}>Download</Button>
        </Col>
      </Row>
    </div>
  );
};

export default ErgebnisView;
